module.exports = __webpack_public_path__ + "static/ChowNow-f314f48972a46fedeb38a26b395107bf.jpg";